module.exports = __webpack_public_path__ + "static/Ultra_Jhakaas-53c3d0045daae278128820f4afcd82da.png";